import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Check2Square, SendCheck, Square } from 'react-bootstrap-icons'
import Access from '../../../../libs/api/services/Access'
import Authentication from '../../../../libs/api/services/Authentication'
import Share from '../../../../libs/api/services/Share'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'

export function AccessList({ allocatedResources, setAllocatedResources, disabled }) {
    const [loading, setLoading] = useState(true)
    const { showError } = useContext(CommonFunctionsContext)
    const [resources, setResources] = useState()
    useEffect(() => {
        const load = async () => {
            setResources(await Access.GetAvailableResources("SHARE").catch(showError))
            setLoading(false)
        }
        load()
    }, [])

    if (loading) return (<div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center h-100'>
        <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
        <b className='p-3'>Loading access privilege</b>
    </div>)
    // return resources && resources.resources && resources.resources.map(resource => <LineItemComponent disabled={disabled} setAllocatedResources={setAllocatedResources} allocatedResources={allocatedResources} {...resource} />)
    return resources && resources.map(resource => <LineItemComponent disabled={disabled} setAllocatedResources={setAllocatedResources} allocatedResources={allocatedResources} {...resource} />)
}

export default function AccessModal({ close, whosInformation }) {
    const [allocatedResources, setAllocatedResources] = useState([])
    const { showError, showToast } = useContext(CommonFunctionsContext)

    const handleSave = () => {

        showToast("Processing Request", <SendCheck />, 7)
        Share.CreateShareRequest({
            requestedBy: { id: Authentication.UserId() },
            shareWith: { id: Authentication.UserId() },
            whosInformation: whosInformation,
            RequestedOn: new Date(),
            resources: allocatedResources.map(res => {
                return {
                    resource: {
                        resource: res.resource,
                        accessType: res.accessType
                    },
                    isApproved: false,
                }
            })
        }).then(res => close(() => { showToast("Your request has been sent", <SendCheck />, 7) }))
            .catch(e => close(() => { showError(e) }))
        // close(() => { console.log(allocatedResources) })
    }
    return (<div className='flex-grow-1 d-flex flex-column mh-100 '>
        <div className='flex-grow-1'>
            <AccessList allocatedResources={allocatedResources} setAllocatedResources={setAllocatedResources} />
        </div>
        <div className='text-center flex-shrink-1'>
            <button onClick={handleSave} className='btn bg-secondary-container'>Save</button>
        </div>
    </div>)
}

const LineItemComponent = ({ human, resource, accessTypes, resources, allocatedResources, setAllocatedResources, disabled }) => {
    const [show, setShow] = useState(false)
    //accessTypes
    // resource{human, resource, resources}
    const handleSelect = (type) => {
        if (disabled) return
        var _res = allocatedResources
        var exists = allocatedResources.find(res =>
            res.resource === resource.resource
            && res.accessType === type
        )
        if (exists)
            _res.splice(_res.indexOf(exists), 1)
        else
            _res.push({
                resource: resource.resource,
                human: resource.human,
                accessType: type
            })
        setAllocatedResources([..._res])
    }
    if (!resource) return <></>
    return (<div key={resource.resource}>
        <div className={`${allocatedResources.find(res => res.resource === resource.resource) && 'bg-primary-container'} d-flex hover-primary`}>
            <div
                onClick={() => setShow(!show)}
                className='flex-grow-1'>
                {resource.human}
            </div>
            {(accessTypes.includes('View') || accessTypes.includes('Admin')) &&
                <div
                    className='p-1'
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleSelect('View')
                    }}>{allocatedResources.find(res =>
                        res.resource === resource.resource
                        && res.accessType === 'View'
                    ) ? <Check2Square /> : <Square />}
                    View </div>
            }
            {(accessTypes.includes('Edit') || accessTypes.includes('Admin')) &&
                <div
                    className='p-1'
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleSelect('Edit')
                    }}>{allocatedResources.find(res =>
                        res.resource === resource.resource
                        && res.accessType === 'Edit'
                    ) ? <Check2Square /> : <Square />}
                    Edit </div>
            }
            {accessTypes.includes('Admin') &&
                <div
                    className='p-1'
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleSelect('Admin')
                    }}>{allocatedResources.find(res =>
                        res.resource === resource.resource
                        && res.accessType === 'Admin'
                    ) ? <Check2Square /> : <Square />}
                    Admin </div>
            }
        </div>
        {resource.resources && show &&
            <div className='ms-2'>
                {resource.resources && resource.resources.map(resource => <LineItemComponent disabled={disabled} setAllocatedResources={setAllocatedResources} allocatedResources={allocatedResources} {...resource} />)}
            </div>
        }
    </div>)
}